import { CvGroup } from '../types/CvGroup';

// The artist's CV. Identity header + ordered sections. Entries with an `href` render as a
// followable external link (see CvPage). Edit here in one place.
export const CV_HEADER = {
    name: 'Dragan Strukelj',
    lines: ['Born 1985, Banja Luka, Bosnia and Herzegovina', 'Based in New York, USA'],
};

export const CV_CONFIG: CvGroup[] = [
    {
        heading: 'Education',
        entries: [
            { primary: 'Academy of Arts, University of Banja Luka', secondary: 'Banja Luka, Bosnia and Herzegovina' },
        ],
    },
    {
        heading: 'Selected Exhibitions',
        entries: [
            {
                primary: 'The 38th Chelsea International Fine Art Competition Exhibition',
                secondary: 'Agora Gallery, New York, NY',
                year: '2024',
            },
        ],
    },
    {
        heading: 'Publications & Features',
        entries: [
            {
                primary: 'A View from the Easel #275',
                secondary: 'Hyperallergic',
                year: '2025',
                href: 'https://hyperallergic.com/a-view-from-the-easel-275/',
            },
            {
                primary: 'Face to Face: July 2025',
                secondary: 'IMPULSE Magazine',
                year: '2025',
                href: 'https://impulsemagazine.com/symposium/face-to-face-july-2025',
            },
            {
                primary: 'Artist Profile: Dragan Strukelj',
                secondary: 'The Art Collector',
                year: '2025',
                href: 'https://theartcollector.org/artist-profile-dragan-strukelj/',
            },
            {
                primary: 'Meet the Collector: Kim Manocherian Is Building Narratives Through Art',
                secondary: 'Observer',
                year: '2025',
                href: 'https://observer.com/2025/11/interview-meet-the-art-collector-kim-manocherian-scheherazade-collection/',
            },
            {
                primary: 'At Collector Kim Manocherian’s Home, Warhols Hang Alongside Flea Market Finds. That’s Just How She Likes It',
                secondary: 'CULTURED Magazine',
                year: '2024',
                href: 'https://www.culturedmag.com/article/2024/08/16/kim-manocherian-collector-new-york',
            },
            {
                primary: 'Boxed In: Unraveling the Invisible Barriers of the Mind Through Surrealist Art with Dragan Strukelj',
                secondary: 'Selfless Art',
                year: '2025',
                href: 'https://www.selflessart.com/post/boxed-in-unraveling-the-invisible-barriers-of-the-mind-through-surrealist-art-with-dragan-strukelj',
            },
        ],
    },
    {
        heading: 'Private Collections',
        entries: [{ primary: 'Kim Manocherian / The Scheherazade Collection' }],
    },
    {
        heading: 'Media',
        entries: [
            { primary: 'Oil on canvas' },
            { primary: 'Works on paper' },
        ],
    },
];
